import styled from 'styled-components';
import * as tokens from '@xingternal/tokens';
export const StyledSearchBar = styled.div `
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  width: 100%;
`;
export const InnerSearchBar = styled.div `
  position: relative;
  width: 100%;
`;
export const Suggestions = styled.div `
  top: 40px;
  width: 100%;
`;
export const Overlay = styled.div `
  background: ${tokens.xdlColorBackground};
  height: 100%;
  left: 0;
  overflow-y: scroll;
  position: fixed;
  top: 0;
  width: 100%;
`;
export const BackButton = styled.div `
  align-items: center;
  display: flex;
  margin-right: 12px;
`;
export const Panel = styled.div `
  background-color: ${tokens.xdlColorBackground};
  display: flex;
  padding: 16px;
  position: fixed;
  width: 100%;
  z-index: 22;
`;
//# sourceMappingURL=SearchBar.styles.js.map